import React from 'react';
import { Box, Grid, Typography, useTheme, Button, useMediaQuery } from '@mui/material';
import { motion } from 'framer-motion';
import stockVideo from '../assets/sim_stock.mp4';
import { Link } from 'react-router-dom';

const slideUpVariant = {
  hidden: { y: 50, opacity: 0 },
  visible: { y: 0, opacity: 1 },
};

export default function AboutSection() {
  const theme = useTheme();

  // Hide video on tablet and mobile (md and below)
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box
      component={motion.section}
      variants={slideUpVariant}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.3 }}
      transition={{ duration: 1.0 }}
      sx={{
        py: { xs: 6, md: 8 },
        px: { xs: 2, md: 6 },
        scrollSnapAlign: 'start',
      }}
    >
      <Grid
        container
        spacing={{ xs: 3, md: 4 }}
        alignItems="center"
        justifyContent="center"
      >
        {/* Left: Video (Desktop Only) */}
        {isDesktop && (
          <Grid item lg={5}>
            <Box
              sx={{
                width: '100%',
                maxWidth: 760,
                mx: 'auto',
                mt: 3,
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: theme.shadows[4],
                aspectRatio: '16 / 9',
                maxHeight: 420,
              }}
            >
              <Box
                component="video"
                src={stockVideo}
                autoPlay
                loop
                muted
                playsInline
                sx={{
                  display: 'block',
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          </Grid>
        )}

        {/* Right: Text */}
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            textAlign: { xs: 'center', lg: 'left' },
            mx: 'auto',
          }}
        >
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: 'bold',
              fontFamily: 'lulo-one',
              color: '#193e2d',
              fontSize: { xs: 'clamp(1.75rem, 6vw, 2.25rem)', md: '3.25rem' },
              lineHeight: 1.15,
            }}
          >
            Affordable. Private. BYOB.
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: '#d89936',
              mb: 2,
            }}
          >
            Just $36 per hour.
          </Typography>

          <Typography variant="body1" fontFamily="Roboto" color="text.secondary">
            Located in Carmel, IN, <strong>Indy Golf Den</strong> delivers a
            premium private golf simulator experience at a fraction of the
            typical $45–$70/hour cost.
          </Typography>

          <Typography
            variant="body1"
            fontFamily="Roboto"
            mt={2.5}
            color="text.secondary"
          >
            Enjoy state-of-the-art technology in a completely private space —
            no crowds, no pressure, and no overpriced bar tabs.
          </Typography>

          <Typography
            variant="body1"
            fontFamily="Roboto"
            mt={2.5}
            color="text.secondary"
          >
            Bring your own drinks. Book only the time you need. Play your way.
          </Typography>

          <Box
            mt={{ xs: 3, md: 4 }}
            sx={{
              textAlign: { xs: 'center', lg: 'left' },
            }}
          >
            <Button
              variant="contained"
              component={Link}
              to="/about"
              sx={{
                background: '#193e2d',
                color: '#e6dcbb',
                fontFamily: 'lulo-one',
                px: 3,
                py: 1.25,
                borderRadius: 2,
                '&:hover': {
                  background: '#142e22',
                },
              }}
            >
              Learn More
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}